import service from '@/utils/server';

const modName='/bd/purchOrder/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};


//初始化更新对象
export const editDetails = data => {
  return service({
    url: modName + 'editDetails',
    method: 'post',
    data
  });
};

//修改方法
export const editData = data => {
  return service({
    url: modName + 'editSubmit',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/bd/order/purchOrder/api/index.js